import { call, put, takeLatest } from "redux-saga/effects";
import {
  submitBulkOrderRequest,
  submitBulkOrderSuccess,
  submitBulkOrderFailure,
} from "../reducer/BulkOrder";

import { postApi } from "../../utils/ApiRequest";

// Saga to handle bulk order submission
export function* submitBulkOrderSaga(action) {
    console.log(action)
  const header = {
    Accept: "application/json",
    contenttype: "application/json",
  };

  try {
    const response = yield call(
      postApi,
      "order/bulkOrder", // API endpoint
      action?.payload,   // Combined formData + products
      header
    );

    if (response?.status === 200 || response?.status === 201) {
      yield put(submitBulkOrderSuccess(response?.data));
      console.log("status:", response.data)
    } else {
      yield put(submitBulkOrderFailure(response?.data));
    }
  } catch (error) {
    yield put(submitBulkOrderFailure(error));
    console.log("err:", error)
  }
}

// Watcher
const watchFunction = [
  (function* () {
    yield takeLatest("BulkOrder/submitBulkOrderRequest", submitBulkOrderSaga);
  })(),
];

export default watchFunction;
